export default "__VITE_ASSET__CYQFurgL__"